import React, { useRef, useEffect } from 'react'

import { Card } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, shape, string, arrayOf, bool } from 'prop-types'

import DropdownItem from './Components/DropdownItem/DropdownItem'

function LicenseDropdown({
  onClose: handleClose,
  licenseConfig,
  showAiContactNote = false,
  locale = 'en',
  onLicenseClick: handleLicenseClick,
}) {
  const dropdownRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        handleClose()
      }
    }

    // Defer listener attachment to prevent the click that opened the dropdown from immediately closing it
    const timer = setTimeout(() => {
      document.addEventListener('click', handleClickOutside)
    }, 0)

    return () => {
      clearTimeout(timer)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [handleClose])

  if (!licenseConfig) {
    return null
  }

  const {
    title,
    description,
    features,
  } = licenseConfig

  return (
    <div ref={dropdownRef}>
      <Card customClass="license-dropdown">
        <div className="license-dropdown__container">
          <DropdownItem
            title={title}
            description={description}
            features={features}
            showAiContactNote={showAiContactNote}
            locale={locale}
            onLicenseClick={handleLicenseClick}
          />
        </div>
      </Card>
    </div>
  )
}

LicenseDropdown.propTypes = {
  onClose: func.isRequired,
  licenseConfig: shape({
    title: string.isRequired,
    features: arrayOf(shape({
      description: string.isRequired,
      isActive: bool.isRequired,
      title: string.isRequired,
      link: string,
    })).isRequired,
  }).isRequired,
  showAiContactNote: bool,
  locale: string,
  onLicenseClick: func.isRequired,
}

export default LicenseDropdown
